import { axios } from 'src/api'
import { CouponTypeId } from 'src/api/models/couponType.model'

export interface ApiSaveCouponParamsData{
  environmentDataId: string
  userToken: string
  couponName: string
  hotelList: string[]
  discountSignedId: string
  discountPercentTypeId: string
  discount: string
  couponType: CouponTypeId
  rateList: string[]
  couponId?: string
  couponCode?: string
  iniDate?: string
  endDate?: string
  bookingWindowIniDate?: string
  bookingWindowEndDate?: string
  maxUse?: string
  nonRefundable?: boolean
  couponMonthPeriod?: string
  cuponEmail?: string
  formData: Partial<Omit<ApiSaveCouponParamsData, 'formData'>>
}

export interface ApiSaveCouponParams{
  serverPath: string
  data: ApiSaveCouponParamsData
}

export interface ApiSaveCouponResponse {
  type: string
  errorList: any[]
  ok: boolean
  valid: boolean
  error?: string
}

export const apiSaveCoupon = ({
  serverPath,
  data
}:ApiSaveCouponParams) => {
  return axios.post<ApiSaveCouponResponse>(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/coupon/savedata`, data)
}
